// extracted by mini-css-extract-plugin
module.exports = {"error":"e404_error__2b5PJ","text1":"e404_text1__3GQ2-"};